import { render, staticRenderFns } from "./CourseList.vue?vue&type=template&id=07c12c8f&scoped=true&"
import script from "./CourseList.vue?vue&type=script&lang=ts&"
export * from "./CourseList.vue?vue&type=script&lang=ts&"
import style0 from "./CourseList.vue?vue&type=style&index=0&id=07c12c8f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c12c8f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VMain } from 'vuetify/lib/components/VMain';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VMain,VRow})
